import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { clean, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    ...data,
    content: data?.content?.map((item: any) => ({
      id: item?.id,
      group: item?.group,
      category: item?.category,
      packageName: item?.packageName,
      edit: 'edit',
      delete: 'delete',
    })),
  }
}

const getAllPackages = (data: any, paginationInfo: any, fileType: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingPackageGetAll),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: {
      inputFilter: {
        ...clean(data),
        fileType: fileType ?? 0,
      },
      configParams: paginationInfo,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAllPackages }
